export const adSlots = {
  homeTop: process.env.NEXT_PUBLIC_ADSENSE_SLOT_HOME_TOP || "",
  homeMid: process.env.NEXT_PUBLIC_ADSENSE_SLOT_HOME_MID || "",
  homeBottom: process.env.NEXT_PUBLIC_ADSENSE_SLOT_HOME_BOTTOM || "",
  toolsTop: process.env.NEXT_PUBLIC_ADSENSE_SLOT_TOOLS_TOP || "",
  toolsMid: process.env.NEXT_PUBLIC_ADSENSE_SLOT_TOOLS_MID || "",
  categoryTop: process.env.NEXT_PUBLIC_ADSENSE_SLOT_CATEGORY_TOP || "",
  categoryMid: process.env.NEXT_PUBLIC_ADSENSE_SLOT_CATEGORY_MID || "",
  toolInContent1: process.env.NEXT_PUBLIC_ADSENSE_SLOT_TOOL_INCONTENT_1 || "",
  toolInContent2: process.env.NEXT_PUBLIC_ADSENSE_SLOT_TOOL_INCONTENT_2 || "",
  toolSidebar: process.env.NEXT_PUBLIC_ADSENSE_SLOT_TOOL_SIDEBAR || "",
  footer: process.env.NEXT_PUBLIC_ADSENSE_SLOT_FOOTER || "",
};
